import {
  LayoutDashboard,
  Inbox,
  MessageSquare,
  Kanban,
  Rocket,
  FileQuestion,
  Building2,
  ShieldCheck,
  Users,
  Mail,
  Settings,
  Layers,
  CalendarCheck,
  Award,
} from 'lucide-react';

export const ADMIN_NAV = [
  { path: '/admin', label: 'Overview', icon: LayoutDashboard, end: true, group: 'Onboarding' },
  { path: '/admin/contacts', label: 'Contacts', icon: MessageSquare, group: 'Onboarding' },
  { path: '/admin/applications', label: 'Applications', icon: Inbox, group: 'Onboarding' },
  { path: '/admin/questionnaire', label: 'InnovAce apply form', icon: FileQuestion, group: 'Onboarding' },
  { path: '/admin/company-profile', label: 'Company profile', icon: Building2, group: 'Onboarding' },
  { path: '/admin/due-diligence', label: 'Due Diligence', icon: ShieldCheck, group: 'Onboarding' },
  { path: '/admin/onboarding', label: 'Onboarding', icon: Kanban, group: 'Onboarding' },
  { path: '/admin/batches', label: 'Batches', icon: Rocket, group: 'Program' },
  { path: '/admin/startups', label: 'Startups', icon: Layers, group: 'Program' },
  { path: '/admin/mentors', label: 'Mentors', icon: Award, group: 'Program' },
  { path: '/admin/daily-tasks', label: 'Daily Tasks', icon: CalendarCheck, group: 'Platform' },
  { path: '/admin/users', label: 'Users', icon: Users, group: 'Platform' },
  { path: '/admin/invites', label: 'Invites', icon: Mail, group: 'Platform' },
  { path: '/admin/config', label: 'Config', icon: Settings, group: 'Platform' },
];

export function getAdminNav(user) {
  const isSuper = (user?.roles || []).includes('superadmin');
  const hasGrant = (user?.adminFeatures || []).some((f) =>
    ['manage_daily_tasks', 'user_management'].includes(f)
  );
  const canManage = isSuper || hasGrant;

  return ADMIN_NAV.map((item) => {
    if (item.path === '/admin/daily-tasks') {
      return {
        ...item,
        label: canManage ? 'Daily Tasks' : 'My Daily Tasks',
      };
    }
    return item;
  });
}

export const ADMIN_TITLES = {
  '/admin': 'Admin Overview',
  '/admin/contacts': 'Contact Inquiries',
  '/admin/applications': 'Applications',
  '/admin/questionnaire': 'InnovAce apply form builder',
  '/admin/company-profile': 'Company profile builder',
  '/admin/due-diligence': 'Due Diligence',
  '/admin/onboarding': 'Onboarding queue',
  '/admin/batches': 'Batches',
  '/admin/startups': 'Startups',
  '/admin/mentors': 'Mentors',
  '/admin/daily-tasks': 'Daily Tasks',
  '/admin/users': 'Users',
  '/admin/invites': 'Staff invites',
  '/admin/config': 'Config',
};

export function adminTitle(pathname) {
  if (ADMIN_TITLES[pathname]) return ADMIN_TITLES[pathname];
  if (pathname.startsWith('/admin/mentors/')) return 'Mentor detail';
  if (pathname.startsWith('/admin/applications/')) return 'Application detail';
  if (pathname.startsWith('/admin/onboarding/')) return 'Onboarding board';
  if (/\/admin\/batches\/[^/]+\/startups\//.test(pathname)) return 'Startup dossier';
  if (pathname.startsWith('/admin/batches/')) return 'Batch detail';
  return 'Admin';
}
